import { Select, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	const [value, setValue] = useState("4");

	const updateValue = (event) => {
		setValue(event.target.value);
	};

	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="controlled" />
			<Select
				items={items}
				onChange={updateValue}
				value={value}
			/>
		</CssColumnGrid>
	);
};